import {EventEmitter, Injectable} from '@angular/core';
import {Store} from "@ngxs/store";
import {RequestService} from "./request.service";
import {ApiConfig} from "../config/api.config";
import {isArray} from "util";
import { query } from '@angular/animations';

@Injectable({
  providedIn: 'root'
})
export class InstrumentoService {

  constructor(private requestService: RequestService) { }

  async obtenerIntrumentos(params, query, hideLoading = false) {

    return await  this.requestService.get('instrumento_index',
      { hideLoading, params, query });
  }

  async lookFor(text: string, hideLoading = true, fuente = [], typeInts= [] ) {

    let params = `nombre=${text}`;

    let str = '';

    if(fuente.length > 0){

      str = '';

      fuente.forEach((item) =>{
        
        str = str != '' ? str+','+item : item ;
      })

      params = params + `&sources=${str}`;

    }

    if(typeInts.length > 0){

      str = '';

      typeInts.forEach((item) =>{
        
        str = str != '' ? str+','+item : item ;
      })

      params = params + `&types=${str}`;

    }

    return await  this.requestService.get('instrumento_livesearch', { hideLoading, query: params });
  }

  async lookForOptions(text: string, hideLoading = true) {

    return await this.requestService.get('options_snapshot', { hideLoading, query: `tickerParam=${text}` });
    
  }

}
